import React from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import './CoreValues.css';
import { 
  FaLightbulb, 
  FaTrophy, 
  FaHandshake, 
  FaUsers, 
  FaHandsHelping, 
  FaBolt, 
  FaGraduationCap, 
  FaTachometerAlt, 
  FaBullseye, 
  FaShieldAlt 
} from 'react-icons/fa';

// Core Values Image
import coreValuesImg from '../../assets/img/team/core.jpg';

const CoreValues = () => {
  const coreValues = [
    {
      id: 1,
      icon: <FaLightbulb size={32} />,
      title: "Innovation",
      description: "We embrace creativity and cutting-edge technology to deliver solutions that drive progress and transformation."
    },
    {
      id: 2,
      icon: <FaTrophy size={32} />,
      title: "Excellence",
      description: "We are committed to delivering high-quality products, services, and training that exceed expectations and set industry standards."
    },
    {
      id: 3,
      icon: <FaHandshake size={32} />,
      title: "Integrity",
      description: "We uphold transparency, honesty, and strong ethical principles in all our operations and relationships."
    },
    {
      id: 4,
      icon: <FaUsers size={32} />,
      title: "Customer Success",
      description: "We prioritize our clients' growth and satisfaction by building solutions that are tailored, scalable, and impactful."
    },
    {
      id: 5,
      icon: <FaHandsHelping size={32} />,
      title: "Collaboration",
      description: "We believe in teamwork—both within our company and with our partners and clients—to foster collective success."
    },
    {
      id: 6,
      icon: <FaShieldAlt size={32} />,
      title: "Security & Responsibility",
      description: "We prioritize data protection, cybersecurity, and responsible digital practices in every solution we develop."
    },
    {
      id: 7,
      icon: <FaBolt size={32} />,
      title: "Empowerment through Technology",
      description: "We are passionate about using technology to empower individuals, organizations, and communities across Africa."
    }
  ];

  // Split core values into groups
  const firstTwoValues = coreValues.slice(0, 2);
  const nextTwoValues = coreValues.slice(2, 4);
  const remainingSixValues = coreValues.slice(4, 10);

  const renderCoreValueCard = (value) => (
    <div key={value.id} className="core-value-card">
      <div className="core-value-card-content">
        {/* Icon */}
        <div className="core-value-icon">
          {value.icon}
        </div>
        
        {/* Title */}
        <h4 className="core-value-title">
          {value.title}
        </h4>
        
        {/* Description */}
        <p className="core-value-desc">
          {value.description}
        </p>
      </div>
    </div>
  );

  return (
    <div className="core-values-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Section Title Start */}
            <SectionTitle
              sectionClass="sec-title text-center mb-60 md-mb-40"
              subtitleClass="sub-title orange"
              subtitle="Our Foundation"
              titleClass="title mb-22"
              title="Core Values That Drive Excellence"
              descClass="desc"
              description="At Syrol Technologies, our core values are the cornerstone of our corporate culture and business operations. These principles guide every decision we make and define our commitment to delivering exceptional results for our clients and stakeholders."
            />
            {/* Section Title End */}
          </div>
        </div>
        
        {/* First Four Values with One Image */}
        <div className="row mb-5">
          {/* First Four Values */}
          <div className="col-lg-6 col-md-12">
            {/* First Two Values */}
            <div className="row mb-4">
              {firstTwoValues.map((value) => (
                <div key={value.id} className="col-md-6 col-sm-6 col-12 mb-4">
                  {renderCoreValueCard(value)}
                </div>
              ))}
            </div>
            
            {/* Next Two Values */}
            <div className="row">
              {nextTwoValues.map((value) => (
                <div key={value.id} className="col-md-6 col-sm-6 col-12 mb-4">
                  {renderCoreValueCard(value)}
                </div>
              ))}
            </div>
          </div>
          
          {/* One Core Values Image */}
          <div className="col-lg-6 d-none d-lg-block">
            <div className="core-values-image-section h-90 d-flex flex-column justify-content-center">
              <img 
                src={coreValuesImg} 
                alt="Syrol Technologies Team" 
                className="core-values-image"
              />
            </div>
          </div>
        </div>
        
        {/* Remaining Six Values in 3-Column Grid */}
        <div className="row">
          {remainingSixValues.map((value) => (
            <div key={value.id} className="col-lg-4 col-md-6 mb-4">
              {renderCoreValueCard(value)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CoreValues;
